import { ValidatorFn } from '@angular/forms';
import { MaxLengthValidator } from '../validations';
import { BaseInput, BaseInputConstructor } from './base-input';

/**
 * Represents the constructor options for TextareaInput.
 *
 * @extends BaseInputConstructor
 */
export interface TextareaConstructor extends BaseInputConstructor {
    /**
     * The number of rows for the textarea.
     */
    rows?: number;
    maxlength?: number | string;
}

/**
 * Represents a textarea input field, which is a UI component allowing the user to enter multi-line text.
 *
 * @extends BaseInput
 */
export class TextareaInput extends BaseInput {
    /**
     * Specifies the type of input as 'textarea'.
     */
    override inputType = 'textarea';
    /**
     * The number of rows for the textarea.
     */
    rows?: number;
    maxlength: number | string | null = null;

    /**
     * Creates a new instance of TextareaInput.
     *
     * @param options - The options for configuring the textarea input.
     *
     * @property {number} [options.rows] - The number of rows for the textarea.
     */
    constructor(options: TextareaConstructor) {
        super(options);
        this.rows = options.rows || 5;
        this.maxlength = options.maxlength || 255;

        const validators: ValidatorFn[] = [];
        if (this.validator) {
            validators.push(this.validator);
        }

        if (options?.maxlength) {
            validators.push(MaxLengthValidator());
        }

        this.setValidators(validators);
    }
    
    clone(): TextareaInput {
        return new TextareaInput(this.__internalConstructor__);
    }
}
